// import React, { createContext, useContext, useState } from 'react';
// import EscPosEncoder from 'esc-pos-encoder'; // Install this via npm

// const PrinterContext = createContext();

// export const PrinterProvider = ({ children }) => {
//   const [printerDevice, setPrinterDevice] = useState(null);
//   const [characteristic, setCharacteristic] = useState(null);
//   const [status, setStatus] = useState('Disconnected');

//   const connectPrinter = async () => {
//     try {
//       setStatus('Connecting...');
//       // 1. Request the device
//       const device = await navigator.bluetooth.requestDevice({
//         filters: [{ services: ['000018f0-0000-1000-8000-00805f9b34fb'] }], 
//         optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
//       });

//       // 2. Connect to GATT Server
//       const server = await device.gatt.connect();
//       const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
//       const char = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

//       setPrinterDevice(device);
//       setCharacteristic(char);
//       setStatus('Connected');
      
//       // Listen for unexpected disconnects
//       device.addEventListener('gattserverdisconnected', () => {
//         setStatus('Disconnected');
//         setCharacteristic(null);
//       });

//     } catch (error) {
//       console.error(error);
//       setStatus('Error: ' + error.message);
//     }
//   };

// const printTest = async () => {
//   if (!characteristic) return alert("Printer not connected!");
  
//   try {
//     const encoder = new EscPosEncoder();
    
//     // DUMMY DATA
//     const invoiceNum = `INV-${Date.now().toString().slice(-6)}`;
//     const currentTime = new Date().toLocaleTimeString('en-US', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: true 
//     });
//     const currentDate = new Date().toLocaleDateString('en-GB');
    
//     // Business dummy data
//     const businessName = "Sayul Redistributions";
//     const businessAddress = "NO 244/2/A.Makola, North, Makola";
//     const businessPhone = "Tel: +94 77 222 2700";
    
//     // Customer dummy data
//     const customerName = "John Smith";
//     const customerCode = "CUST001";
    
//     // Sales info dummy data
//     const salesRep = "David Miller";
//     const route = "Route A";
//     const inventory = "Main Warehouse";
    
//     // Dummy product items
//     const dummyProducts = [
//       { category: "ELECTRONIC", name: "Mouse Wireless", qty: 2, price: 2500.00 },
//       { category: "STATIONERY", name: "Notebook A4", qty: 5, price: 450.00 },
//       { category: "BEVERAGES", name: "Coca-Cola 1.5L", qty: 3, price: 320.00 },
//       { category: "ELECTRONIC", name: "USB Cable", qty: 1, price: 850.00 },
//     ];
    
//     // Dummy payments
//     const dummyPayments = [
//       { method: "CASH", amount: 5000.00 },
//       { method: "CREDIT", amount: 3270.00 },
//     ];
    
//     // Dummy totals
//     const subTotal = 8270.00;
//     const returns = 0.00;
//     const netTotal = 8270.00;
//     const paidAmount = 8270.00;
//     const remainingBalance = 0.00;
//     const changeDue = 0.00;

//     // Build the receipt with dummy data
//     const receipt = encoder
//       .initialize()
//       .codepage('cp858')
      
//       // ==================== BUSINESS HEADER ====================
//     .align('center')
//     .size(2, 2)
//     .bold(true)
//     .line(   businessName)
//     .line(' ')
//     .size(1, 1)
//     .bold(false)
//     .line(businessAddress)
//     .line(businessPhone)
//     .line(' ')
//     .line('='.repeat(42))
    
      
//       // ==================== INVOICE DETAILS ====================
//       .align('left')
//       .bold(true)
//       .line('INVOICE DETAILS')
//       .bold(false)
//       .line('─'.repeat(32))
//       .line(`Invoice # : ${invoiceNum}`)
//       .line(`Date/Time : ${currentDate} ${currentTime}`)
//       .line(`Customer  : ${customerName}`)
//       .line(`Cust Code : ${customerCode}`)
//       .line(`Sales Rep : ${salesRep}`)
//       .line(`Route     : ${route}`)
//       .line(`Inventory : ${inventory}`)
//       .line('='.repeat(42))
      
//       // ==================== PRODUCTS SECTION ====================
//       .align('center')
//       .bold(true)
//       .line('PRODUCTS')
//       .bold(false)
//       .line('─'.repeat(42))
      
//       // Table Header
//       .align('center')
//       .bold(true)
//       .line('   Category    Product        Qty   Price')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     // Add dummy products
//     dummyProducts.forEach(item => {
//       const category = item.category.padEnd(11);
//       const product = item.name.substring(0, 14).padEnd(15);
//       const qty = item.qty.toString().padStart(3);
//       const price = item.price.toFixed(2).padStart(8);
      
//       receipt.line(`${category}${product}${qty}${price}`);
//     });
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== TOTALS ====================
//     receipt
//       .align('right')
//       .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
    
//     // Returns (if any)
//     if (returns > 0) {
//       receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
//     }
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== PAYMENT METHODS ====================
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT METHODS')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     dummyPayments.forEach(payment => {
//       const method = payment.method.padEnd(16);
//       const amount = payment.amount.toFixed(2).padStart(10);
//       receipt.line(`${method}${amount}`);
//     });
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== FINAL TOTAL ====================
//     receipt
//       .align('right')
//       .bold(true)
//       .size('double')
//       .line('─'.repeat(32))
//       .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//       .size('normal')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     // ==================== PAYMENT SUMMARY ====================
//     receipt
//       .align('left')
//       .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
    
//     if (remainingBalance > 0) {
//       receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//     } else if (changeDue > 0) {
//       receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//     } else {
//       receipt.line(`Payment    : FULLY PAID`);
//     }
    
//     // ==================== FOOTER ====================
//     receipt
//        .line('='.repeat(42))
//     .line(' ')
//     .align('center')
//     .bold(true)
//     .line('THANK YOU!')
//     .bold(false)
//     .line('We value your business')
//     .line('Please visit again')
//     .newline()
//     .newline()
//     .cut('partial');
    
//     // ENCODE the receipt
//     const encodedData = receipt.encode();
    
//     console.log('Dummy receipt size:', encodedData.byteLength, 'bytes');
    
//     // Write to printer in chunks
//     const CHUNK_SIZE = 480;
//     const buffer = encodedData;
//     const totalBytes = buffer.byteLength;
//     let offset = 0;
    
//     console.log(`Writing dummy receipt (${totalBytes} bytes)...`);
    
//     while (offset < totalBytes) {
//       const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//       const chunk = buffer.slice(offset, offset + chunkSize);
      
//       await characteristic.writeValue(chunk);
//       console.log(`Written chunk: ${chunkSize} bytes`);
      
//       // Small delay between chunks
//       await new Promise(resolve => setTimeout(resolve, 50));
      
//       offset += chunkSize;
//     }
    
//     console.log('Dummy receipt printed successfully!');
//     alert("Test receipt printed successfully!");
    
//   } catch (error) {
//     console.error('Print test error:', error);
//     alert("Printing failed: " + error.message);
//   }
// };

// // Add this test button to your JSX
// // <button onClick={printTest} className="btn-test">
// //   <i className="fas fa-print"></i> Test Receipt (Dummy Data)
// // </button>

//   return (
//     <PrinterContext.Provider value={{ status, connectPrinter, printTest, characteristic }}>
//       {children}
//     </PrinterContext.Provider>
//   );
// };

// export const usePrinter = () => useContext(PrinterContext);


// import React, { createContext, useContext, useState } from 'react';
// import EscPosEncoder from 'esc-pos-encoder'; // Install this via npm

// const PrinterContext = createContext();

// export const PrinterProvider = ({ children }) => {
//   const [printerDevice, setPrinterDevice] = useState(null);
//   const [characteristic, setCharacteristic] = useState(null);
//   const [status, setStatus] = useState('Disconnected');

//   const connectPrinter = async () => {
//     try {
//       setStatus('Connecting...');
//       // 1. Request the device
//       const device = await navigator.bluetooth.requestDevice({
//         filters: [{ services: ['000018f0-0000-1000-8000-00805f9b34fb'] }], 
//         optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
//       });

//       // 2. Connect to GATT Server
//       const server = await device.gatt.connect();
//       const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
//       const char = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

//       setPrinterDevice(device);
//       setCharacteristic(char);
//       setStatus('Connected');
      
//       // Listen for unexpected disconnects
//       device.addEventListener('gattserverdisconnected', () => {
//         setStatus('Disconnected');
//         setCharacteristic(null);
//       });

//     } catch (error) {
//       console.error(error);
//       setStatus('Error: ' + error.message);
//     }
//   };

// const printTest = async () => {
//   if (!characteristic) return alert("Printer not connected!");
  
//   try {
//     const encoder = new EscPosEncoder();
    
//     // DUMMY DATA
//     const invoiceNum = `INV-${Date.now().toString().slice(-6)}`;
//     const currentTime = new Date().toLocaleTimeString('en-US', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: true 
//     });
//     const currentDate = new Date().toLocaleDateString('en-GB');
    
//     // Business dummy data
//     const businessName = "Sayul Redistributions";
//     const businessAddress = "NO 244/2/A.Makola, North, Makola";
//     const businessPhone = "Tel: +94 77 222 2700";
    
//     // Customer dummy data
//     const customerName = "John Smith";
//     const customerCode = "CUST001";
    
//     // Sales info dummy data
//     const salesRep = "David Miller";
//     const route = "Route A";
//     const inventory = "Main Warehouse";
    
//     // Dummy product items
//     const dummyProducts = [
//       { category: "ELECTRONIC", name: "Mouse Wireless", qty: 2, price: 2500.00 },
//       { category: "STATIONERY", name: "Notebook A4", qty: 5, price: 450.00 },
//       { category: "BEVERAGES", name: "Coca-Cola 1.5L", qty: 3, price: 320.00 },
//       { category: "ELECTRONIC", name: "USB Cable", qty: 1, price: 850.00 },
//     ];
    
//     // Dummy payments
//     const dummyPayments = [
//       { method: "CASH", amount: 5000.00 },
//       { method: "CREDIT", amount: 3270.00 },
//     ];
    
//     // Dummy totals
//     const subTotal = 8270.00;
//     const returns = 0.00;
//     const netTotal = 8270.00;
//     const paidAmount = 8270.00;
//     const remainingBalance = 0.00;
//     const changeDue = 0.00;

//     // Build the receipt with dummy data
//     const receipt = encoder
//       .initialize()
//       .codepage('cp858')
      
//       // ==================== BUSINESS HEADER ====================
//     .align('center')
//     .size(2, 2)
//     .bold(true)
//     .line(   businessName)
//     .line(' ')
//     .size(1, 1)
//     .bold(false)
//     .line(businessAddress)
//     .line(businessPhone)
//     .line(' ')
//     .line('='.repeat(42))
    
      
//       // ==================== INVOICE DETAILS ====================
//       .align('left')
//       .bold(true)
//       .line('INVOICE DETAILS')
//       .bold(false)
//       .line('─'.repeat(32))
//       .line(`Invoice # : ${invoiceNum}`)
//       .line(`Date/Time : ${currentDate} ${currentTime}`)
//       .line(`Customer  : ${customerName}`)
//       .line(`Cust Code : ${customerCode}`)
//       .line(`Sales Rep : ${salesRep}`)
//       .line(`Route     : ${route}`)
//       .line(`Inventory : ${inventory}`)
//       .line('='.repeat(42))
      
//       // ==================== PRODUCTS SECTION ====================
//       .align('center')
//       .bold(true)
//       .line('PRODUCTS')
//       .bold(false)
//       .line('─'.repeat(42))
      
//       // Table Header
//       .align('center')
//       .bold(true)
//       .line('   Category    Product        Qty   Price')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     // Add dummy products
//     dummyProducts.forEach(item => {
//       const category = item.category.padEnd(11);
//       const product = item.name.substring(0, 14).padEnd(15);
//       const qty = item.qty.toString().padStart(3);
//       const price = item.price.toFixed(2).padStart(8);
      
//       receipt.line(`${category}${product}${qty}${price}`);
//     });
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== TOTALS ====================
//     receipt
//       .align('right')
//       .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
    
//     // Returns (if any)
//     if (returns > 0) {
//       receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
//     }
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== PAYMENT METHODS ====================
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT METHODS')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     dummyPayments.forEach(payment => {
//       const method = payment.method.padEnd(16);
//       const amount = payment.amount.toFixed(2).padStart(10);
//       receipt.line(`${method}${amount}`);
//     });
    
//     receipt.line('─'.repeat(42));
    
//     // ==================== FINAL TOTAL ====================
//     receipt
//       .align('right')
//       .bold(true)
//       .size('double')
//       .line('─'.repeat(32))
//       .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//       .size('normal')
//       .bold(false)
//       .line('─'.repeat(42));
    
//     // ==================== PAYMENT SUMMARY ====================
//     receipt
//       .align('left')
//       .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
    
//     if (remainingBalance > 0) {
//       receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//     } else if (changeDue > 0) {
//       receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//     } else {
//       receipt.line(`Payment    : FULLY PAID`);
//     }
    
//     // ==================== FOOTER ====================
//     receipt
//        .line('='.repeat(42))
//     .line(' ')
//     .align('center')
//     .bold(true)
//     .line('THANK YOU!')
//     .bold(false)
//     .line('We value your business')
//     .line('Please visit again')
//     .newline()
//     .newline()
//     .cut('partial');
    
//     // ENCODE the receipt
//     const encodedData = receipt.encode();
    
//     console.log('Dummy receipt size:', encodedData.byteLength, 'bytes');
    
//     // Write to printer in chunks
//     const CHUNK_SIZE = 480;
//     const buffer = encodedData;
//     const totalBytes = buffer.byteLength;
//     let offset = 0;
    
//     console.log(`Writing dummy receipt (${totalBytes} bytes)...`);
    
//     while (offset < totalBytes) {
//       const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//       const chunk = buffer.slice(offset, offset + chunkSize);
      
//       await characteristic.writeValue(chunk);
//       console.log(`Written chunk: ${chunkSize} bytes`);
      
//       // Small delay between chunks
//       await new Promise(resolve => setTimeout(resolve, 50));
      
//       offset += chunkSize;
//     }
    
//     console.log('Dummy receipt printed successfully!');
//     alert("Test receipt printed successfully!");
    
//   } catch (error) {
//     console.error('Print test error:', error);
//     alert("Printing failed: " + error.message);
//   }
// };

// // Add this test button to your JSX
// // <button onClick={printTest} className="btn-test">
// //   <i className="fas fa-print"></i> Test Receipt (Dummy Data)
// // </button>

//   return (
//     <PrinterContext.Provider value={{ status, connectPrinter, printTest, characteristic }}>
//       {children}
//     </PrinterContext.Provider>
//   );
// };

// export const usePrinter = () => useContext(PrinterContext);

// import React, { createContext, useContext, useState, useEffect } from 'react';

// const PrinterContext = createContext();

// export const PrinterProvider = ({ children }) => {
//   const [printerDevice, setPrinterDevice] = useState(null);
//   const [characteristic, setCharacteristic] = useState(null);
//   const [status, setStatus] = useState('Disconnected');
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect mobile device
//   useEffect(() => {
//     const checkMobile = () => {
//       const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//       const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
//       const isAndroid = /android/i.test(userAgent);
//       setIsMobile(isIOS || isAndroid || window.innerWidth <= 768);
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Check Web Bluetooth support
//   const isBluetoothSupported = () => {
//     if (typeof navigator === 'undefined' || !navigator.bluetooth) {
//       return false;
//     }
    
//     // iOS specific checks (limited support)
//     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//     if (isIOS) {
//       // iOS 17.1+ has partial Web Bluetooth support
//       const versionMatch = navigator.userAgent.match(/OS (\d+)_(\d+)/);
//       if (versionMatch) {
//         const majorVersion = parseInt(versionMatch[1], 10);
//         const minorVersion = parseInt(versionMatch[2], 10);
//         // iOS 17.1+ required
//         return majorVersion > 17 || (majorVersion === 17 && minorVersion >= 1);
//       }
//       return false;
//     }
    
//     return true;
//   };

//   // Enhanced connection function for mobile
//   const connectPrinter = async () => {
//     try {
//       // Check support
//       if (!isBluetoothSupported()) {
//         const errorMsg = isMobile 
//           ? 'Web Bluetooth not supported on your mobile browser. Please use Chrome/Edge on Android.'
//           : 'Web Bluetooth not supported in this browser.';
//         setStatus('Error: Not Supported');
//         alert(errorMsg);
//         return;
//       }

//       // Check HTTPS on mobile
//       if (isMobile && window.location.protocol !== 'https:') {
//         setStatus('Error: HTTPS Required');
//         alert('Web Bluetooth requires HTTPS on mobile devices.');
//         return;
//       }

//       setStatus('Connecting...');
      
//       // Mobile-specific: Use try-catch for permission errors
//       let device;
//       try {
//         device = await navigator.bluetooth.requestDevice({
//           filters: [{ 
//             services: ['000018f0-0000-1000-8000-00805f9b34fb'] 
//           }],
//           optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
//           acceptAllDevices: false // Better compatibility
//         });
//       } catch (error) {
//         if (error.name === 'NotFoundError') {
//           setStatus('No Device Selected');
//           return;
//         }
//         if (error.name === 'SecurityError') {
//           setStatus('Error: Permission Denied');
//           alert('Please grant Bluetooth permission in your browser settings.');
//           return;
//         }
//         throw error;
//       }

//       if (!device) {
//         setStatus('Disconnected');
//         return;
//       }

//       // Connect with timeout for mobile
//       const connectWithTimeout = async (device) => {
//         const timeoutPromise = new Promise((_, reject) => {
//           setTimeout(() => reject(new Error('Connection timeout')), 10000);
//         });
        
//         const connectPromise = device.gatt.connect();
//         return Promise.race([connectPromise, timeoutPromise]);
//       };

//       const server = await connectWithTimeout(device);
//       const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
//       const char = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

//       setPrinterDevice(device);
//       setCharacteristic(char);
//       setStatus('Connected');
      
//       // Handle disconnections
//       device.addEventListener('gattserverdisconnected', () => {
//         setStatus('Disconnected');
//         setCharacteristic(null);
//         setPrinterDevice(null);
//       });

//       console.log('Connected to printer:', device.name || 'Unknown Device');

//     } catch (error) {
//       console.error('Connection error:', error);
      
//       // User-friendly error messages for mobile
//       let errorMessage = 'Connection failed';
//       if (error.name === 'NotFoundError') {
//         errorMessage = 'No Bluetooth printer found nearby';
//       } else if (error.name === 'SecurityError') {
//         errorMessage = 'Bluetooth permission denied';
//       } else if (error.message === 'Connection timeout') {
//         errorMessage = 'Connection timeout. Make sure printer is on and nearby';
//       } else {
//         errorMessage = error.message;
//       }
      
//       setStatus('Error: ' + errorMessage);
//       alert(errorMessage);
//     }
//   };

//   const printTest = async () => {
//     if (!characteristic) return alert("Printer not connected!");
    
//     try {
//       // Dynamically import esc-pos-encoder
//       const EscPosEncoder = (await import('esc-pos-encoder')).default;
//       const encoder = new EscPosEncoder();
      
//       // DUMMY DATA
//       const invoiceNum = `INV-${Date.now().toString().slice(-6)}`;
//       const currentTime = new Date().toLocaleTimeString('en-US', { 
//         hour: '2-digit', 
//         minute: '2-digit',
//         hour12: true 
//       });
//       const currentDate = new Date().toLocaleDateString('en-GB');
      
//       // Business dummy data
//       const businessName = "Sayul Redistributions";
//       const businessAddress = "NO 244/2/A.Makola, North, Makola";
//       const businessPhone = "Tel: +94 77 222 2700";
      
//       // Customer dummy data
//       const customerName = "John Smith";
//       const customerCode = "CUST001";
      
//       // Sales info dummy data
//       const salesRep = "David Miller";
//       const route = "Route A";
//       const inventory = "Main Warehouse";
      
//       // Dummy product items
//       const dummyProducts = [
//         { category: "ELECTRONIC", name: "Mouse Wireless", qty: 2, price: 2500.00 },
//         { category: "STATIONERY", name: "Notebook A4", qty: 5, price: 450.00 },
//         { category: "BEVERAGES", name: "Coca-Cola 1.5L", qty: 3, price: 320.00 },
//         { category: "ELECTRONIC", name: "USB Cable", qty: 1, price: 850.00 },
//       ];
      
//       // Dummy payments
//       const dummyPayments = [
//         { method: "CASH", amount: 5000.00 },
//         { method: "CREDIT", amount: 3270.00 },
//       ];
      
//       // Dummy totals
//       const subTotal = 8270.00;
//       const returns = 0.00;
//       const netTotal = 8270.00;
//       const paidAmount = 8270.00;
//       const remainingBalance = 0.00;
//       const changeDue = 0.00;

//       // Build the receipt with dummy data
//       const receipt = encoder
//         .initialize()
//         .codepage('cp858')
        
//         // ==================== BUSINESS HEADER ====================
//         .align('center')
//         .size(2, 2)
//         .bold(true)
//         .line(businessName)
//         .line(' ')
//         .size(1, 1)
//         .bold(false)
//         .line(businessAddress)
//         .line(businessPhone)
//         .line(' ')
//         .line('='.repeat(42))
        
//         // ==================== INVOICE DETAILS ====================
//         .align('left')
//         .bold(true)
//         .line('INVOICE DETAILS')
//         .bold(false)
//         .line('─'.repeat(32))
//         .line(`Invoice # : ${invoiceNum}`)
//         .line(`Date/Time : ${currentDate} ${currentTime}`)
//         .line(`Customer  : ${customerName}`)
//         .line(`Cust Code : ${customerCode}`)
//         .line(`Sales Rep : ${salesRep}`)
//         .line(`Route     : ${route}`)
//         .line(`Inventory : ${inventory}`)
//         .line('='.repeat(42))
        
//         // ==================== PRODUCTS SECTION ====================
//         .align('center')
//         .bold(true)
//         .line('PRODUCTS')
//         .bold(false)
//         .line('─'.repeat(42))
        
//         // Table Header
//         .align('center')
//         .bold(true)
//         .line('   Category    Product        Qty   Price')
//         .bold(false)
//         .line('─'.repeat(42));
      
//       // Add dummy products
//       dummyProducts.forEach(item => {
//         const category = item.category.padEnd(11);
//         const product = item.name.substring(0, 14).padEnd(15);
//         const qty = item.qty.toString().padStart(3);
//         const price = item.price.toFixed(2).padStart(8);
        
//         receipt.line(`${category}${product}${qty}${price}`);
//       });
      
//       receipt.line('─'.repeat(42));
      
//       // ==================== TOTALS ====================
//       receipt
//         .align('right')
//         .line(`Sub Total: ${subTotal.toFixed(2).padStart(10)}`);
      
//       // Returns (if any)
//       if (returns > 0) {
//         receipt.line(`Returns  : -${returns.toFixed(2).padStart(10)}`);
//       }
      
//       receipt.line('─'.repeat(42));
      
//       // ==================== PAYMENT METHODS ====================
//       receipt
//         .align('left')
//         .bold(true)
//         .line('PAYMENT METHODS')
//         .bold(false)
//         .line('─'.repeat(42));
      
//       dummyPayments.forEach(payment => {
//         const method = payment.method.padEnd(16);
//         const amount = payment.amount.toFixed(2).padStart(10);
//         receipt.line(`${method}${amount}`);
//       });
      
//       receipt.line('─'.repeat(42));
      
//       // ==================== FINAL TOTAL ====================
//       receipt
//         .align('right')
//         .bold(true)
//         .size('double')
//         .line('─'.repeat(32))
//         .line(`TOTAL: Rs.${netTotal.toFixed(2).padStart(10)}`)
//         .size('normal')
//         .bold(false)
//         .line('─'.repeat(42));
      
//       // ==================== PAYMENT SUMMARY ====================
//       receipt
//         .align('left')
//         .line(`Paid Amount: ${paidAmount.toFixed(2).padStart(10)}`);
      
//       if (remainingBalance > 0) {
//         receipt.line(`Balance Due: ${remainingBalance.toFixed(2).padStart(10)}`);
//       } else if (changeDue > 0) {
//         receipt.line(`Change Due : ${changeDue.toFixed(2).padStart(10)}`);
//       } else {
//         receipt.line(`Payment    : FULLY PAID`);
//       }
      
//       // ==================== FOOTER ====================
//       receipt
//         .line('='.repeat(42))
//         .line(' ')
//         .align('center')
//         .bold(true)
//         .line('THANK YOU!')
//         .bold(false)
//         .line('We value your business')
//         .line('Please visit again')
//         .newline()
//         .newline()
//         .cut('partial');
      
//       // ENCODE the receipt
//       const encodedData = receipt.encode();
      
//       console.log('Dummy receipt size:', encodedData.byteLength, 'bytes');
      
//       // Write to printer in chunks
//       const CHUNK_SIZE = isMobile ? 200 : 480;
//       const buffer = encodedData;
//       const totalBytes = buffer.byteLength;
//       let offset = 0;
      
//       console.log(`Writing dummy receipt (${totalBytes} bytes)...`);
      
//       while (offset < totalBytes) {
//         const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//         const chunk = buffer.slice(offset, offset + chunkSize);
        
//         await characteristic.writeValue(chunk);
//         console.log(`Written chunk: ${chunkSize} bytes`);
        
//         // Small delay between chunks (longer for mobile)
//         await new Promise(resolve => setTimeout(resolve, isMobile ? 100 : 50));
        
//         offset += chunkSize;
//       }
      
//       console.log('Dummy receipt printed successfully!');
//       alert("Test receipt printed successfully!");
      
//     } catch (error) {
//       console.error('Print test error:', error);
//       alert("Printing failed: " + error.message);
//     }
//   };

//   return (
//     <PrinterContext.Provider value={{ 
//       status, 
//       connectPrinter, 
//       printTest, 
//       characteristic,
//       printerDevice,
//       isMobile,
//       isBluetoothSupported: isBluetoothSupported()
//     }}>
//       {children}
//     </PrinterContext.Provider>
//   );
// };

// export const usePrinter = () => useContext(PrinterContext);
// import React, { createContext, useContext, useState, useEffect } from 'react';
// import EscPosEncoder from 'esc-pos-encoder'; // Ensure this is installed

// const PrinterContext = createContext();

// export const PrinterProvider = ({ children }) => {
//   const [printerDevice, setPrinterDevice] = useState(null);
//   const [characteristic, setCharacteristic] = useState(null);
//   const [status, setStatus] = useState('Disconnected');
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkMobile = () => {
//       const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//       setIsMobile(/android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream));
//     };
//     checkMobile();
//   }, []);

//   const connectPrinter = async () => {
//     try {
//       setStatus('Connecting...');
//       const device = await navigator.bluetooth.requestDevice({
//         filters: [{ services: ['000018f0-0000-1000-8000-00805f9b34fb'] }],
//         optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
//       });

//       const server = await device.gatt.connect();
//       const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
//       const char = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

//       setPrinterDevice(device);
//       setCharacteristic(char);
//       setStatus('Connected');

//       device.addEventListener('gattserverdisconnected', () => {
//         setStatus('Disconnected');
//         setCharacteristic(null);
//       });
//     } catch (error) {
//       console.error(error);
//       setStatus('Error: ' + error.message);
//     }
//   };

//   // NEW: Robust Printing Logic for Mobile
//   const printReceipt = async (encodedData) => {
//     if (!characteristic) {
//       alert("Printer not connected!");
//       return;
//     }

//     try {
//       // Mobile Bluetooth stacks (especially Android) struggle with large MTU
//       // 20 bytes is the safest "Universal" BLE MTU, though 512 is common.
//       // We will use 100 bytes to balance speed and reliability.
//       const CHUNK_SIZE = isMobile ? 100 : 512; 
//       const buffer = encodedData;
      
//       for (let offset = 0; offset < buffer.byteLength; offset += CHUNK_SIZE) {
//         const chunk = buffer.slice(offset, offset + CHUNK_SIZE);
        
//         // writeValueWithResponse is safer on mobile than writeValueWithoutResponse
//         await characteristic.writeValue(chunk);
        
//         // Crucial for Mobile: Allow the printer's physical buffer to catch up
//         // If it skips lines, increase this delay (e.g., to 150)
//         if (isMobile) {
//           await new Promise(resolve => setTimeout(resolve, 80)); 
//         }
//       }
      
//       console.log('Print complete');
//     } catch (error) {
//       console.error('Print Error:', error);
//       alert("Printing failed: " + error.message);
//     }
//   };

//   return (
//     <PrinterContext.Provider value={{ 
//       status, 
//       connectPrinter, 
//       printReceipt, // Use this instead of printTest
//       characteristic,
//       isMobile 
//     }}>
//       {children}
//     </PrinterContext.Provider>
//   );
// };

// export const usePrinter = () => useContext(PrinterContext);

import React, { createContext, useContext, useState, useEffect } from 'react';
import EscPosEncoder from 'esc-pos-encoder'; // Ensure this is installed
import { BUSINESS_NAME, BUSINESS_ADDRESS, BUSINESS_PHONE } from '../utils/config';

const PrinterContext = createContext();

export const PrinterProvider = ({ children }) => {
  const [printerDevice, setPrinterDevice] = useState(null);
  const [characteristic, setCharacteristic] = useState(null);
  const [status, setStatus] = useState('Disconnected');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      setIsMobile(/android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream));
    };
    checkMobile();
  }, []);

  const connectPrinter = async () => {
    try {
      setStatus('Connecting...');
      const device = await navigator.bluetooth.requestDevice({
        filters: [{ services: ['000018f0-0000-1000-8000-00805f9b34fb'] }],
        optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
      });

      const server = await device.gatt.connect();
      const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
      const char = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

      setPrinterDevice(device);
      setCharacteristic(char);
      setStatus('Connected');

      device.addEventListener('gattserverdisconnected', () => {
        setStatus('Disconnected');
        setCharacteristic(null);
      });
    } catch (error) {
      console.error(error);
      setStatus('Error: ' + error.message);
    }
  };

  // NEW: Robust Printing Logic for Mobile
  const printReceipt = async (encodedData) => {
    if (!characteristic) {
      alert("Printer not connected!");
      return;
    }

    try {
      // Mobile Bluetooth stacks (especially Android) struggle with large MTU
      // 20 bytes is the safest "Universal" BLE MTU, though 512 is common.
      // We will use 100 bytes to balance speed and reliability.
      const CHUNK_SIZE = isMobile ? 100 : 512; 
      const buffer = encodedData;
      
      for (let offset = 0; offset < buffer.byteLength; offset += CHUNK_SIZE) {
        const chunk = buffer.slice(offset, offset + CHUNK_SIZE);
        
        // writeValueWithResponse is safer on mobile than writeValueWithoutResponse
        await characteristic.writeValue(chunk);
        
        // Crucial for Mobile: Allow the printer's physical buffer to catch up
        // If it skips lines, increase this delay (e.g., to 150)
        if (isMobile) {
          await new Promise(resolve => setTimeout(resolve, 80)); 
        }
      }
      
      console.log('Print complete');
    } catch (error) {
      console.error('Print Error:', error);
      alert("Printing failed: " + error.message);
    }
  };

  // ADDED: Test printer function
  const printTest = async () => {
    if (!characteristic) {
      alert("Printer not connected!");
      return;
    }

    try {
      const encoder = new EscPosEncoder();
      
      // Create a simple test receipt
      const testReceipt = encoder
        .initialize()
        .codepage('cp858')
        .align('center')
        .size(2, 2)
        .bold(true)
        .line('TEST RECEIPT')
        .size(1, 1)
        .bold(false)
        .line(' ')
        .line('='.repeat(32))
        .align('left')
        .line(BUSINESS_NAME)
        .line(' ')
               .line(BUSINESS_ADDRESS)
                      .line(' ')
                      .line(BUSINESS_PHONE)
        // .line('Connection: OK')
        // .line(`Mobile: ${isMobile ? 'Yes' : 'No'}`)
        // .line(`Status: ${status}`)
        // .line(' ')
        .line('='.repeat(32))
        .align('center')
        .line(' ')
        .line('All systems working!')
        .line(' ')
        .cut('partial')
        .encode();
      
      // Use the existing printReceipt logic
      await printReceipt(testReceipt);
      
      alert("Test receipt printed successfully!");
      
    } catch (error) {
      console.error('Print test error:', error);
      alert("Print test failed: " + error.message);
    }
  };

  return (
    <PrinterContext.Provider value={{ 
      status, 
      connectPrinter, 
      printReceipt,
      printTest, // Added test function
      characteristic,
      isMobile 
    }}>
      {children}
    </PrinterContext.Provider>
  );
};

export const usePrinter = () => useContext(PrinterContext);
